// extracted by mini-css-extract-plugin
export default {"layout":"yS6EBy3EUN_catalogue"};